export const SHOW_WEEKENDS_VALUES = ["BOTH", "SATURDAY_ONLY", "SUNDAY_ONLY", "NONE"] as const;

export type ShowWeekendsOption = typeof SHOW_WEEKENDS_VALUES[number];

export const SHOW_WEEKENDS_OPTIONS: { label: string; value: ShowWeekendsOption }[] = [
  { label: "Sobota oraz niedziela", value: "BOTH" },
  { label: "Tylko sobota", value: "SATURDAY_ONLY" },
  { label: "Tylko niedziela", value: "SUNDAY_ONLY" },
  { label: "Nie pokazuj", value: "NONE" },
];

export const SHOW_WEEKENDS_LABELS: Record<ShowWeekendsOption, string> = SHOW_WEEKENDS_OPTIONS.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  {} as Record<ShowWeekendsOption, string>
);

// Fallback for values cached in localStorage before showWeekends became a 4-option enum
// (it used to be a plain boolean) - normalizes any legacy/unknown value to a valid option
// without requiring the user to log in again.
export const normalizeShowWeekends = (value: unknown): ShowWeekendsOption => {
  if (typeof value === "string" && (SHOW_WEEKENDS_VALUES as readonly string[]).includes(value)) {
    return value as ShowWeekendsOption;
  }
  if (typeof value === "boolean") {
    return value ? "BOTH" : "NONE";
  }
  return "BOTH";
};

export const getHiddenWeekendDays = (showWeekends: ShowWeekendsOption): number[] => {
  switch (showWeekends) {
    case "SATURDAY_ONLY":
      return [0];
    case "SUNDAY_ONLY":
      return [6];
    case "NONE":
      return [0, 6];
    default:
      return [];
  }
};
